module.exports = {
  title: 'Shared Element Transitions with Reanimated 🔄',
  author: 'Enzo Manuel Mangano',
  date: '2023-03-08',
  slug: 'shared-transitions',
  tags: ['reanimated', 'react-navigation'],
};
